import React from 'react';
        import {Text, View, StyleSheet } from '@react-pdf/renderer';
        
        const borderColor = '#90e5fc'
        
        const styles = StyleSheet.create({
            row: {
                flexDirection: 'row',
                display: 'flex',
                height: 15,
                fontSize: 8,
            },
            description: {
                width: '85%',
                textAlign: 'right',
                paddingRight: 8,
            },
            total: {
                width: '15%',
                textAlign: 'center',
                paddingRight: 8,
                backgroundColor: '#e2e2e2',
                fontStyle: 'bold'
            },
        });
        const round = (num) => {
            let m = Number((Math.abs(num) * 100).toPrecision(15));
            return Math.round(m) / 100 * Math.sign(num);
        }
        
        const refreshTotal = (header, Items) => {
            Items.map(item => {
                item.TaxeResult = round(item.ImpuestoRow/ (header.DocRate || 1)).toFixed(2);
                item.Total = round(item.LineTotal / (header.DocRate || 1)).toFixed(2);
            });
            let subTotal = 0;
            let impuestos = 0;
            let discount = 0;
            let total = 0;
        
            for (let index = 0; index < Items.length; index++) {
                const item = Items[index];
                item.TaxeResult = round(item.ImpuestoRow/ (header.DocRate || 1)).toFixed(2) ;
                subTotal += Number(item.Total);         
                impuestos += parseFloat(parseFloat(item.TaxeResult).toFixed(2));
            }
        
            discount = subTotal * (header.DiscPrcnt / 100);
            total =  parseFloat(parseFloat(subTotal).toFixed(2) - parseFloat(discount).toFixed(2) ) + parseFloat(parseFloat(impuestos).toFixed(2));
            
            let totals = {
                Subtotal: parseFloat(subTotal).toFixed(2),
                Discount: parseFloat(discount).toFixed(2),
                Taxes :parseFloat(impuestos).toFixed(2),
                Total: parseFloat(total).toFixed(2),
            }
            return totals;
        };
        
        const TableFooterPayments = ({header,items,view, balanceDueTotal}) => {
            let order = refreshTotal(header,items);
            return( 
                
                <View>
                    <View style={styles.row}>
                        <Text style={styles.description}>Pago a cuenta</Text>
                        <Text style={styles.total}>{Number.parseFloat(header.NoDocSum).toFixed(2) || "0.00"}</Text>
                    </View>
                    <View style={styles.row}>
                        <Text style={styles.description}>Saldo vencido</Text>
                        <Text style={styles.total}>{ Number.parseFloat(balanceDueTotal).toFixed(2) || "0.00"}</Text>
                    </View>
                    <View style={styles.row}>
                        <Text style={styles.description}>Pago total</Text>
                        <Text style={styles.total}>{Number.parseFloat(header.DocTotal).toFixed(2) || "0.00"}</Text>
                    </View>
                </View>
            )
        };
          
          export default TableFooterPayments